import { useMemo } from 'react';
import { SearchableDropdown } from "views/UIelems/v2/searchable-dropdown/SearchableDropdown";
import { useDiscountsContext } from "./Discount.Context";
import { useUpdateDiscountItem } from "./hooks/useUpdateDiscountItem";

const OMITTED_BASE_CONSULT_IDS = [
  "-Nl0JsszlQ7bYEcnyein",
  "-NyRifI_Z6YLfv4J--km",
];
const ConsultSelector = () => {
  const {
    state: { availableConsults, selectedDiscount },
  } = useDiscountsContext();

  const updateDiscountItem = useUpdateDiscountItem();
  const onChange = (value) => {
    updateDiscountItem("selected_consults", value);
  };

  const dropdownOptions = availableConsults
      .filter(consult => !(OMITTED_BASE_CONSULT_IDS.includes(consult.c) || consult.t === "s"))
      .map(consult => ({
        text: `${consult.n} (${consult.c})`,
        value: consult.c,
      }));

  const value = useMemo(() => {
    return selectedDiscount.selected_consults ?? [];
  }, [selectedDiscount.selected_consults]);

  return (
    <SearchableDropdown
      placeholder={"Select consultations"}
      options={dropdownOptions}
      value={value}
      onSelectionChange={onChange}
      hasSearch={true}
    />
  );
};

export default ConsultSelector;
